/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { LinkProps } from "next/link";

//Additional anchor element props
interface AnchorProps {
	target?: string;
}

export type NextLinkType = LinkProps & AnchorProps;
export type CosmosLinkType = NextLinkType;
export type CosmosLinkReactElementType = React.ElementType<NextLinkType>;

export const DefaultLink = (props: NextLinkType): React.JSX.Element => {
	// link content passed via props, so no need to lint here
	// eslint-disable-next-line jsx-a11y/anchor-has-content
	return <a {...props} href={(props.href || "") as string} />;
};
